const isDevelop = process.env.NODE_ENV === 'development';

export const facebookLoginUrl = isDevelop
  ? 'http://localhost:8337/oauth2/authorize/facebook?redirect_uri=http://localhost:3000/interstitial.html'
  : `${window.location.origin}/oauth2/authorize/facebook?redirect_uri=${window.location.origin}/interstitial.html`;

export const googleLoginUrl = isDevelop
  ? 'http://localhost:8337/oauth2/authorize/google?redirect_uri=http://localhost:3000/interstitial.html'
  : `${window.location.origin}/oauth2/authorize/google?redirect_uri=${window.location.origin}/interstitial.html`;

export const appleLoginUrl = isDevelop
  ? 'http://localhost:8337/oauth2/authorize/apple?redirect_uri=http://localhost:3000/interstitial.html'
  : `${window.location.origin}/oauth2/authorize/apple?redirect_uri=${window.location.origin}/interstitial.html`;